import React from 'react'

import FreezerBoxIcon from '../../vectors/FreezerBoxIcon'
import useTranslation from '../../context/hooks/useTranslation'
import { twm } from '../../lib/utils/twm'

export interface FreezerReturnBannerProps {
  className?: string
}

export const FreezerReturnBanner: React.FC<FreezerReturnBannerProps> = ({
  className,
}) => {
  const { t, trans: Trans } = useTranslation()

  return (
    <div
      className={twm('flex w-[332px] flex-col items-center gap-4', className)}
    >
      <FreezerBoxIcon size={160} />

      <div className="bg-yellow-light-fade flex w-full flex-row items-center justify-center gap-2 rounded-[4px] px-4 py-3 text-center">
        <span className="font-heading font-normal text-md text-indigo-50">
          <Trans
            t={t}
            i18nKey="RETURNS_SCAN.FREEZER_RETURN_BANNER"
            components={{
              b: <span className="font-bold" />,
            }}
          />
        </span>
      </div>
    </div>
  )
}

export default FreezerReturnBanner
